import sentpaymentFullcont  from "./sentpayment-fullcont.html";

const dialog           = require ('../../../../../components/dialog/dialog')
const fullcontEntity   = require ('../../../../../components/fullcont/fullcont-entity')
const fullcontHandler  = require ('../../../../../components/fullcont/fullcont-handler')
const sentpaymentDt    = require ('./sentpayment-dt')
const sentpaymentMenu  = require ('./sentpayment-menu')
const handler          = require ('./sentpayment-fullcont-handler')
const jumperHandler    = require ('./sentpayment-fullcont-jumper-handler')
const navmenu          = require ('../../../../../components/navmenu/navmenu')
const {formCopy}       = require ('./sentpayment-fullcont-form') 
const {form}           = require ('./sentpayment-fullcont-form')
const {sentpaymentMT}  = require ('./sentpayment-fullcont-multitable')
// const sentpaymentMT = undefined
const timeDate         = require ('../../../../../js-handler/time-date')

/****************ELEMENTS*****************/
var htmlFc          = {}
var HTMLwasSelected = false

function HTMLselect(detail){ 

	fullcontHandler.HTMLselect(

            'sentpayment', //database table name****
            'sentpayment', //dest entity on js
            'sentpayment-fullcont', 
             sentpaymentFullcont, form, formCopy, sentpaymentMT, 
             editDialog, deleteDialog, dtCall, htmlFc)

	HTMLwasSelected   = true  

      // htmlFc.hasFiles = true
      // fullcontHandler.rightsControl(htmlFc)
}/**/


export function start(detail){  //console.log('sentpayment-dt 5>', detail)
  
      if(!HTMLwasSelected) { HTMLselect(detail) }
       
      obj[detail.act].start(detail)
}/**/

const obj = {

      addOne:           { start: (detail)=>{  if (handler.verifyMultitable(detail,htmlFc)){addOne(detail, htmlFc)} }},
      addOnePrint:      { start: (detail)=>{  if (handler.verifyMultitable(detail,htmlFc)){addOne(detail, htmlFc, afterProcessAndPrint)} }},
      cancelEdit:       { start: (detail)=>{  fullcontEntity.cancelEdit(detail, htmlFc)                 }},
      deleteEntity:     { start: (detail)=>{  deleteEntity(detail, htmlFc)                              }},
      deleteFromDialog: { start: (detail)=>{  deleteFromDialog(detail, htmlFc)                          }},
      discard:          { start: (detail)=>{  discard(detail, htmlFc)                                   }},
      fullcontOptions:  { start: (detail)=>{  sentpaymentMenu.start(detail, 'htmlDt', htmlFc )       }},
      hide:             { start: (detail)=>{  fullcontEntity.hide(detail, htmlFc)                       }},
      prepareAdd:       { start: (detail)=>{  fullcontEntity.prepareAdd(detail, htmlFc, setDefaultValue)}},
      prepareEdit:      { start: (detail)=>{  fullcontHandler.prepareEdit(detail, htmlFc)               }},
      saveFromDialog:   { start: (detail)=>{   if (handler.verifyMultitable(detail,htmlFc)){
                                                     fullcontEntity.saveFromDialog(detail, htmlFc,afterprocess) 
                                                }                                                       }},
      selectOne:        { start: (detail)=>{  selectOne(detail, htmlFc)                                               }},
      selectOneNoCheck:      { start: (detail)=>{  fullcontEntity.selectOneNoCheck(detail, htmlFc,afterprocess)      }},
      update:           { start: (detail)=>{   if (handler.verifyMultitable(detail,htmlFc)){
                                                     fullcontEntity.update(detail, htmlFc,afterprocess) 
                                                }                                                       }},
      updatePrint:      { start: (detail)=>{   if (handler.verifyMultitable(detail,htmlFc)){
                                                     fullcontEntity.update(detail, htmlFc,afterProcessAndPrint)
                                                }                                                       }},
      getAllInvoice:    { start: (detail)=>{  handler.getAllInvoice(detail, htmlFc)                     }},
      jumperToPurchase: { start: (detail)=>{  jumperHandler.jumperToPurchase(detail)                    }},
      validated_press:  { start: (detail)=>{  handler.validated_press(detail, htmlFc)                   }},
      reportPdf:        { start: (detail)=>{  handler.reportPdf(detail, htmlFc, afterCheckPrint)        }},
      addAmount:        { start: (detail)=>{  handler.addAmount(detail, htmlFc)                         }},
      toggleCheckGeneration: { start: ()=>{   handler.toggleCheckGeneration(htmlFc, true)               }},
      updateCheckAmount: { start: ()=>{        handler.updateCheckAmount(htmlFc)                         }},
      syncCheckDate:     { start: ()=>{        handler.syncCheckDate(htmlFc)                             }},

}/**/

//function to send
function editDialog(){
	dialog.start({ act:"show", id:"saveChanges", entity:'sentpayment' } )
}

function deleteDialog(detail){
	dialog.start({ act:"show",  dest:'sentpayment', id:"deleteElem", entity:'sentpayment', dbid: detail.dbid } )
}

function dtCall(act, result){ 
	sentpaymentDt.start({act:act, row: result})
}

function addOne(detail, htmlFc, callback){

      fullcontEntity.addOne(detail, htmlFc, callback)
      setTimeout(()=>{
           // investorDt.start({"dest":"investor", "elem":"dt", "act":"select", "entity":"investor"})  
      },100)                  
}

function deleteFromDialog(detail, htmlFc){

      fullcontEntity.deleteFromDialog(detail, htmlFc) 
      setTimeout(()=>{
            sentpaymentDt.start({"dest":"sentpayment", "elem":"dt", "act":"select", "entity":"sentpayment"})  
      },900)                
}

//Function to set default values to fullcont fields when creating a record is pressed
function setDefaultValue(htmlFc){

      let sale_date  = htmlFc.fullcontHTML.querySelector('#sentpayment_form_date input');
      let amount = htmlFc.fullcontHTML.querySelector('#sentpayment_form_amount input');
      sale_date.value = timeDate.convertDateToInput();
      amount.value = '0';


      htmlFc.formCopy.forEach(element => {

            if (element.name == "date") {
                  element.value=sale_date.value;
            }

            if (element.name == "amount") {
                  element.value=amount.value;
            }
      });

      handler.toggleCheckGeneration(htmlFc)
}

function discard(detail, htmlFc) {
      fullcontHandler.discard(detail, htmlFc)
      handler.toggleCheckGeneration(htmlFc)
}

function selectOne(detail, htmlFc) {
      fullcontEntity.selectOne(detail, htmlFc, afterprocess)

      navmenu.start({
            act: 'renderNavMenu',
            container: '#sentpayment-navmenu-container',
            items: [
                  {
                        label: 'Sent Payment',
                        icon: 'docs',
                        dest: 'sentpayment',
                        action: 'reportPdf',
                        extraData: {
                              entity: 'sentpayment',
                              report: 'sentpayment-one',
                              id: '',
                              elem: 'fullcont'
                        }
                  },
                  {
                        label: 'Check',
                        icon: 'receipt',
                        dest: 'sentpayment',
                        action: 'reportPdf',
                        extraData: {
                              entity: 'sentpayment',
                              report: 'sentpayment-check',
                              id: '',
                              elem: 'fullcont'
                        }
                  }
            ]
      })
}

async function deleteEntity(detail,htmlFc) {
      if (await handler.verifySentHasPurchaseWithCredit(detail.dbid.join(','),htmlFc)) {
            fullcontEntity.deleteEntity(detail, htmlFc)
      }

}

function afterprocess(data, result) {
      if (result?.restriction?.val && result.restriction.val !== 'ok') { return false }

      handler.blockPurchaseHasCredit(data,htmlFc)
      handler.toggleCheckGeneration(htmlFc)

      return true
}

function afterProcessAndPrint(data, result) {
      if (!afterprocess(data, result) || !data?.id) { return }

      handler.reportPdf({
            id: data.id,
            entity: 'sentpayment',
            checkGenerationActive: data.check_generation_active,
      }, htmlFc, afterCheckPrint)
}

function afterCheckPrint(data) {
      if (!htmlFc.fullcontHTML.classList.contains('fullcont-show')) { return }

      const ids = Array.isArray(data?.ids) ? data.ids.map(String) : []
      const currentId = htmlFc.fullcontHTML.getAttribute('data-dbid')

      if (!ids.includes(String(currentId))) { return }

      const checkStatusField = htmlFc.form.find((field) => field.name === 'check_status')
      const checkStatusCopy = htmlFc.formCopy.find((field) => field.name === 'check_status')

      if (checkStatusField === undefined || checkStatusField.value === 'Clear') { return }

      checkStatusField.value = 'Printed'
      const statusSelect = checkStatusField.html?.querySelector('select')
      if (statusSelect !== null && statusSelect !== undefined) {
            statusSelect.value = 'Printed'
      }

      // Mantiene la copia sincronizada para que el fullcont no figure como editado.
      if (checkStatusCopy !== undefined) {
            checkStatusCopy.value = 'Printed'
      }
}


